<section class="section">
  <h2 class="section-header">Attachments ({{ pages }})</h2>

  <div class="preview">
    <article class="preview__previews">
      <app-fax-pages-previews
        *ngIf="blobSrc"
        [src]="blobSrc"
        [columns]="2"
        (loadComplete)="onLoadCompleteSavePagesCount($event)"
        (selectPage)="selectPage($event)"
      ></app-fax-pages-previews>
    </article>

    <app-fax-pdf-viewer
      *ngIf="blobSrc"
      [faxFileSrc]="blobSrc"
      [faxFilePage]="activePage"
      [showControls]="false"
    ></app-fax-pdf-viewer>
  </div>

  <div class="send-page__actions">
    <button (click)="navigateToPreviousPage()" class="btn_secondary btn_md section__back">
      <img src="assets/img/icons/arrow_back.svg" alt="return back" />
      Edit
    </button>
    <button
      (click)="submitPreview()"
      form="send-fax-final-step"
      class="btn_primary btn_md section__button_next"
    >
      Next
    </button>
  </div>
</section>
